import React, { useEffect, useState, useRef } from 'react';
import {
  AiOutlinePlusCircle,
  AiOutlineDelete,
  AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import { Modal, Button, Table, Form } from "react-bootstrap";
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from 'react-icons/ci';
import { MdLocalPrintshop } from "react-icons/md";
import logo from '../../../assets/logo.png'
import { useLocation } from 'react-router-dom';
import { useLoading } from '../../../context/LoadingContext';



function Appraisal({adminData}) {

  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [user, setUser] = useState([]);
  const { setLoading } = useLoading();
  const [formItems, setFormItems] = useState({
    appraisal_type: '',
    remark_first:'',
    remark_second:'',
    sale_person:'',
  })

  const [showOptionModal, setShowOptionModal] = useState(false);
  const [newOptionValue, setNewOptionValue] = useState("");
  const [activeDropdown, setActiveDropdown] = useState("");
  const [type, setType] = useState([]);
  const [clientRows, setClientRows] = useState([]);
const [managerRows, setManagerRows] = useState([]);
const [ratingOptions, setRatingOptions] = useState([]);
  const [parameter, setParameter] = useState([]);
   const [isEditMode, setIsEditMode] = useState(false);
   const[finalAppr,setFinalAppr] = useState([]);

  const [rows, setRows] = useState([
    { col1: "", col2: "", col3: "" }
  ]);
        const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState("");

       

  const handleAddRow = () => {
    setRows([...rows, { col1: "", col2: "", col3: "" }]);
  };

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
      setToast({ show: true, message: msg, bg });
    };

    const monthOptions = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" }
];

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleDeleteClientRow = (index) => {
  setClientRows(prev => prev.filter((_, i) => i !== index));
};

const handleDeleteManagerRow = (index) => {
  setManagerRows(prev => prev.filter((_, i) => i !== index));
};

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const [sourceOptions, setSourceOptions] = useState([
    { value: "Adaptabilty/Flexibility", label: "Adaptabilty/Flexibility" },
    { value: "Decision Making/Judgement", label: "Decision Making/Judgement" },
    { value: "Communication", label: "Communication" }
  ]);

  const [appraisalType, setAppraisalType] = useState([
    { value: "Managerial Appraisal", label: "Managerial Appraisal" },

  ]);



  const handleFormOpen = () => {
    setShowForm(true);
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const fectEmphDetail = async () => {
    setLoading(true)
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
       const filtered = (resEmployee.data.result || []).filter(
      emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
    );

    setUser(filtered);


    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

const fetchType = async () => {
  setLoading(true);
  try {
    const res = await axios.get('https://api.skyguard.group/api/fetch-appraisal-type');

    const formatted = res.data.map(item => ({
      value: item.id,
      label: item.name,

      parameters: JSON.parse(item.parameter_row || "[]"),
      ratings: JSON.parse(item.rating_row || "[]")
    }));

    setType(formatted);

  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

 const fetchRating = async () => {
  setLoading(true);
  try {
    const res = await axios.get('https://api.skyguard.group/api/fetch-rating');

    const formatted = res.data.map(item => ({
      value: item.value,
      label: item.name
    }));

    setRatingOptions(formatted);

  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

 const fetchAppraisal = async () => {
  setLoading(true);
  try {
    const res = await axios.get('https://api.skyguard.group/api/fetch-main-appraisal');
   setFinalAppr(res.data);
  
console.log(res.data);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fectEmphDetail();
    fetchType();
    fetchRating();
    fetchAppraisal();

  }, []);


const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    employee_id: formItems.sale_person,
    appraisal_type: formItems.appraisal_type,

    remark_first: formItems.remark_first,
    remark_second: formItems.remark_second,

    month: selectedMonth,

    client_data: clientRows.map(row => ({
      parameter: row.parameter,
      rating: row.rating,
      comment: row.comment
    })),

    manager_data: managerRows.map(row => ({
      parameter: row.parameter,
      rating: row.rating,
      comment: row.comment
    }))
  };

  try {

    let res;

    if (isEditMode) {
      payload.id = formItems.id;
      payload.edit_by = adminData.user.id;

      res = await axios.put(
        "https://api.skyguard.group/api/update-appraisal",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      showToast("Appraisal updated successfully!", "success");

    } else {
      payload.added_by = adminData.user.id;

      res = await axios.post(
        "https://api.skyguard.group/api/save-appraisal",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      showToast("Appraisal saved successfully!", "success");
    }

    setShowForm(false);
    resetForm();
    setIsEditMode(false);
    fetchRating();
    fetchAppraisal();

  } catch (err) {
    console.log("❌ Submit Error:", err);
    showToast("Failed to save appraisal!", "danger");
  }
};

 const handleEdit = (form) => {


  fetchRating();

  setFormItems({
    id: form.id || '',
    sale_person: form.employee_id || '',
    appraisal_type: form.appraisal_type || '',
    remark_first: form.client_remark || '',
    remark_second: form.manager_remark || ''
  });

  setSelectedMonth(form.month || "");


  setClientRows(form.client_data || []);
  setManagerRows(form.manager_data || []);

  setEditingCompanyId(form.id);
  setIsEditMode(true);
  setShowForm(true);
};

  const resetForm = () => {
  setFormItems({
    appraisal_type: "",
    sale_person: "",
    remark_first: "",
    remark_second: ""
  });

  setClientRows([]);
  setManagerRows([]);
  setRatingOptions([]);
  setEditingCompanyId(null);
setIsEditMode(false);
};

const safeFinalAppr = Array.isArray(finalAppr) ? finalAppr : [];

const filteredData = safeFinalAppr.filter(itm => {
  const search = searchTerm.toLowerCase();

  return (
    String(itm.employee_name || "").toLowerCase().includes(search) ||
    String(itm.appraisal_type_name || "").toLowerCase().includes(search)
  );
});




  return (
    <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'> Appraisal</h3>
        <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
          <div className="col-12 col-md-5">
            <input
              type="text"
              className="form-control border-0 border-bottom border-dark"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-2 d-flex justify-content-end">
            <button className='btn btn-success' onClick={handleFormOpen}>
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>

        {showForm && (
          <div className="card p-3 my-3 shadow-sm bg-white border">
            <form onSubmit={handleSubmit}>
              <div className="row">

                <div className='col-12'>
                  <div className="row g-3">

                    <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">Employee Name</label>
                      <Select
                        options={user.map((t) => ({
                          value: t.id,
                          label: `${t.first} ${t.last} (${t.emp_id})`,
                        }))}


                        value={
                          user
                            .map((t) => ({
                              value: t.id,
                              label: `${t.first} ${t.last} (${t.emp_id})`,
                            }))
                            .find((opt) => opt.value == formItems.sale_person) || null
                        }
                        onChange={(e) =>
                          handleChange({ target: { name: "sale_person", value: e.value } })
                        }
                        className="w-100"
                        menuPlacement="auto"
                      />


                    </div>

                    <div className="col-12 col-md-4 d-flex align-items-center">

                      <div className="flex-grow-1">
                        <label className="form-label fw-medium">Appraisal Type</label>
                       <Select
  options={type}
  value={type.find(opt => opt.value === formItems.appraisal_type) || null}
  onChange={(selected) => {
    setFormItems({ ...formItems, appraisal_type: selected.value });

    const selectedType = type.find(t => t.value === selected.value);

    // fill tables
    setClientRows(
      selectedType.parameters.map(p => ({
        parameter: p.parameterName,
        rating: "",
        comment: ""
      }))
    );

    setManagerRows(
      selectedType.parameters.map(p => ({
        parameter: p.parameterName,
        rating: "",
        comment: ""
      }))
    );

  }}
/>
                      </div>


                    </div>


                   <div className="col-12 col-md-4">
  <label className="form-label fw-medium">Month</label>

  <Select
    options={monthOptions}
    value={monthOptions.find(m => m.value === selectedMonth) || null}
    onChange={(selected) => setSelectedMonth(selected.value)}
    placeholder="Select Month"
  />
</div>

                    {/* table */}

                    <div className="col-12">



                      {/* Table */}
                      <span>By Client</span>
                      <div className='table-resposnive'>
                        <table className="table table-bordered ">
                          <thead className="table-info">
                            <tr>
                              <th>Parameter</th>
                              <th>Rating</th>
                              <th>Comment</th>
                              <th width="120">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                           {clientRows.map((row, index) => (
  <tr key={index}>
    <td>{row.parameter}</td>
<td>
  <Select
    options={ratingOptions}
    value={ratingOptions.find(r => r.label === row.rating) || null}
    onChange={(selected) => {
      const updated = [...clientRows];
      updated[index].rating = selected.label;
      setClientRows(updated);
    }}
  />
</td>

    <td>
      <input
        className="form-control"
        value={row.comment}
        onChange={(e) => {
          const updated = [...clientRows];
          updated[index].comment = e.target.value;
          setClientRows(updated);
        }}
      />
    </td>


  <td className="text-center">
    <button
      type="button"
      className="btn btn-danger btn-sm"
      onClick={() => handleDeleteClientRow(index)}
    >
      Delete
    </button>
  </td>
  </tr>
))}
                          </tbody>

                          <tfoot>

                            <div className="col-12 col-md-12">
                              <label className="form-label fw-medium">Remark </label>
                              <input
                                name="remark_first"
                                className="form-control w-100"
                                placeholder="Enter parameter name"
                                value={formItems.remark_first}
                                onChange={handleChange}
                              />
                            </div>
                          </tfoot>
                        </table>
                      </div>

                      <span>By Manager</span>
                      <div className='table-resposnive'>
                        <table className="table table-bordered ">
                          <thead className="table-info">
                            <tr>
                              <th>Parameter</th>
                              <th>Rating</th>
                              <th>Comment</th>
                              <th width="120">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {managerRows.map((row, index) => (
  <tr key={index}>
    <td>{row.parameter}</td>

<td>
  <Select
    options={ratingOptions}
    value={ratingOptions.find(r => r.label === row.rating) || null}
    onChange={(selected) => {
      const updated = [...managerRows];
      updated[index].rating = selected.label;
      setManagerRows(updated);
    }}
  />
</td>

    <td>
      <input
        className="form-control"
        value={row.comment}
        onChange={(e) => {
          const updated = [...managerRows];
          updated[index].comment = e.target.value;
          setManagerRows(updated);
        }}
      />
    </td>
      <td className="text-center">
    <button
      type="button"
      className="btn btn-danger btn-sm"
      onClick={() => handleDeleteManagerRow(index)}
    >
      Delete
    </button>
  </td>
  </tr>
))}
                          </tbody>
                          <tfoot>

                            <div className="row ">
                              <label className="form-label fw-medium">Remark </label>
                              <input
                                name="remark_second"
                                className="form-control w-100"
                                placeholder="Enter parameter name"
                                value={formItems.remark_second}
                                onChange={handleChange}
                              />
                            </div>
                          </tfoot>
                        </table>
                      </div>

                    </div>




                  </div>
                </div>


                <div className='gap-2 d-flex justify-content-center mt-4'>
                  <button type="submit" className='btn btn-success w-10'>
                    {isEditMode ? "Update" : "Save"}
                   
                  </button>
                  <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                    setShowForm(false);
                         resetForm();

                  }}>
                    Cancel
                  </button>
                </div>


              </div>
            </form>
          </div>

        )}


        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                <th scope='col'>SN </th>
                  <th scope='col' >Action</th>
                <th scope='col' >Empooyee Name</th>
                <th scope='col' >Appraisal Type</th>
                <th scope='col'>Month</th>
                <th scope='col'>Client Remark</th>
                <th scope='col'> Manager Remark</th>
                  <th scope='col'>Added By</th>
                   <th scope='col'> Edit By</th>
              
              </tr>
            </thead>

             <tbody>
                 {filteredData.map((acc, idx) => (
                <tr key={idx} >
                     <td>{idx + 1}</td>
                    <td> 
                       <button
                    className="btn btn-success"
                   
                    onClick={() => handleEdit(acc)}
                  >
                    <CiEdit size={20} />
                  </button>
                  </td>
                  <td> {acc.employee_name} </td>
                     <td> {acc.appraisal_type_name} </td>
                     <td>{acc.month} </td>
               <td className="text-wrap" style={{ maxWidth: "300px" }}>
  {acc.client_remark}
</td>

 <td className="text-wrap" style={{ maxWidth: "300px" }}>
  {acc.manager_remark}
</td>
<td>{acc.added_by_name} </td>
<td>{acc.edit_by_name || '-'} </td>
                </tr>
              ))}
             </tbody>

          </table>
        </div>


 
      </div>
    </div>
  )
}

export default Appraisal